import { defineTour } from '@lopettia/simul';

/**
 * Platform administrator — tenants, demo catalogue, stat refresh queue
 * (epic 114, ticket 114.8). Mirrors docs/manuals/11-platform-admin.md.
 */
export const platformAdminTour = defineTour({
  name: 'Platform administration',
  description:
    'Cross-tenant view: tenant list, prospect-demo catalogue, and the stat '
    + 'refresh queue powering catalog template snapshots.',
  steps: [
    {
      id: 'pa-tenants',
      kind: 'navigate',
      target: '[data-tour-id="nav-platform-admin"]',
      toUrl: '/admin/platform',
      prelude: { goto: '/dashboard' },
      message:
        '**Platform admin** is the cross-tenant control plane — tenants, '
        + 'feature flags, system health.',
      advanceOn: 'navigate',
    },
    {
      id: 'pa-catalog',
      kind: 'navigate',
      target: '[data-tour-id="nav-demo-catalog"]',
      toUrl: '/admin/demos/catalog',
      message:
        'The **demo catalog** is the shared library of prospect-demo '
        + 'templates every tenant can fork.',
      advanceOn: 'navigate',
    },
    {
      id: 'pa-stat-refresh',
      kind: 'info',
      target: '[data-tour-id="demo-catalog-refresh-queue"]',
      message:
        'The **stat refresh queue** lets a platform admin re-run the '
        + 'Claude-backed template snapshot job on demand.',
      advanceOn: 'manual',
    },
  ],
});

export default platformAdminTour;
